import { c as _c } from "react/compiler-runtime";
import { OptimizelyDecideOption as Options } from '@optimizely/optimizely-sdk';
import join from 'url-join';
import { Cookie, useOptimizely } from '@libs/common-next';
import { useOverrides } from '../../store';
import type { Flag } from '../../types';
export function useFlag(flag) {
  const $ = _c(18);
  const {
    context,
    instance
  } = useOptimizely();
  const {
    overrides,
    setOverride
  } = useOverrides();
  let t0;
  if ($[0] !== context || $[1] !== flag.key) {
    t0 = context?.decide(flag.key, [Options.DISABLE_DECISION_EVENT])?.variables.value;
    $[0] = context;
    $[1] = flag.key;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const original = t0;
  const t1 = overrides[flag.key] ?? original;
  let t2;
  if ($[3] !== flag.key || $[4] !== flag.options.length || $[5] !== instance || $[6] !== original || $[7] !== overrides || $[8] !== setOverride || $[9] !== t1) {
    let t3;
    if ($[11] !== overrides) {
      t3 = Object.keys(overrides);
      $[11] = overrides;
      $[12] = t3;
    } else {
      t3 = $[12];
    }
    const t4 = t3.includes(flag.key);
    let t5;
    if ($[13] !== instance) {
      t5 = instance?.getProjectConfig()?.projectId;
      $[13] = instance;
      $[14] = t5;
    } else {
      t5 = $[14];
    }
    const t6 = `${t5}`;
    let t7;
    if ($[15] !== flag.key || $[16] !== t6) {
      t7 = join("https://app.optimizely.com/v2/projects", t6, "/flags/manage", flag.key, "/variations");
      $[15] = flag.key;
      $[16] = t6;
      $[17] = t7;
    } else {
      t7 = $[17];
    }
    t2 = {
      value: t1,
      onChange(newV) {
        const value = {
          ...overrides,
          [flag.key]: newV
        };
        if (String(newV) === String(original)) {
          delete value[flag.key];
        }
        Cookie.set("x-petm-override", JSON.stringify(value));
        setOverride(value);
      },
      disabled: flag.options.length < 2,
      isOverride: t4,
      link: t7
    };
    $[3] = flag.key;
    $[4] = flag.options.length;
    $[5] = instance;
    $[6] = original;
    $[7] = overrides;
    $[8] = setOverride;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
}